import { render, staticRenderFns } from "./GameSection.vue?vue&type=template&id=1c2157ba&scoped=true&"
import script from "./GameSection.vue?vue&type=script&lang=js&"
export * from "./GameSection.vue?vue&type=script&lang=js&"
import style0 from "./GameSection.vue?vue&type=style&index=0&id=1c2157ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2157ba",
  null
  
)

export default component.exports